import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "cartCount",
    "submitButton",
    "totalCount",
    "totalPrice",
    "totalSummary",
    "items",
    "categoryTabs"
  ]
  static values = {
    initialCart: Object,
    brandId:     Number
  }

  connect() {
    this.items = []
    this.totalSummaryData = {}

    // 옵션 선택 모달(#modals, 이 컨트롤러 DOM 범위 밖)에서 담기 완료 시 쏘는 이벤트.
    // kiosk-option-select 컨트롤러가 자체 fetch로 처리하므로, 여기서는 결제 버튼/
    // 수량 표시만 동기화한다.
    this.boundCartUpdated = (event) => this.updateUI(event.detail)
    window.addEventListener("kiosk:cart-updated", this.boundCartUpdated)

    if (this.hasInitialCartValue) {
      const initial = this.initialCartValue
      this.items = initial.items || []
      this.totalSummaryData = initial.total_summary || {}
      this.updateUI(initial)
    }
  }

  disconnect() {
    window.removeEventListener("kiosk:cart-updated", this.boundCartUpdated)
  }

  // ── 카테고리 탭 좌우 스크롤 ────────────────────────────────

  scrollCategoryLeft() {
    this.categoryTabsTarget.scrollBy({ left: -400, behavior: "smooth" })
  }

  scrollCategoryRight() {
    this.categoryTabsTarget.scrollBy({ left: 400, behavior: "smooth" })
  }

  // ── 장바구니 조작 ──────────────────────────────────────────

  async addItem(event) {
    event.preventDefault()
    const posItemId = event.currentTarget.dataset.posItemId
    await this.cartRequest("cart_add_item", { pos_item_id: posItemId })
  }

  async incrementItem(event) {
    event.preventDefault()
    const posItemId = event.currentTarget.dataset.posItemId
    const code = event.currentTarget.dataset.code
    const count = parseInt(event.currentTarget.dataset.currentCount) + 1
    await this.cartRequest("cart_set_count", { pos_item_id: posItemId, count, code })
  }

  async decrementItem(event) {
    event.preventDefault()
    const posItemId = event.currentTarget.dataset.posItemId
    const code = event.currentTarget.dataset.code
    const count = parseInt(event.currentTarget.dataset.currentCount) - 1
    await this.cartRequest("cart_set_count", { pos_item_id: posItemId, count, code })
  }

  async removeItem(event) {
    event.preventDefault()
    const code = event.currentTarget.dataset.code
    await this.cartRequest("cart_remove", { code })
  }

  async cartRequest(action, payload) {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(`/pos/${this.brandIdValue}/kiosk_${action}`, {
        method:  "POST",
        headers: {
          "X-CSRF-Token": csrf,
          "Content-Type": "application/json",
          "Accept":       "text/vnd.turbo-stream.html, application/json"
        },
        body: JSON.stringify(payload)
      })

      const contentType = response.headers.get("Content-Type") || ""
      if (contentType.includes("application/json")) {
        const data = await response.json()
        if (data.status !== "ok") console.warn("Kiosk cart:", data.message)
        return
      }

      const html = await response.text()
      window.Turbo.renderStreamMessage(html)

      const cartHeader = response.headers.get("X-Kiosk-Cart")
      if (cartHeader) {
        const cartData = JSON.parse(cartHeader)
        this.items = cartData.items || []
        this.totalSummaryData = cartData.total_summary || {}
        this.updateUI(cartData)
      }
    } catch (e) {
      console.error("Kiosk cart request failed:", e)
    }
  }

  updateUI(cartData) {
    const ts = cartData.total_summary || {}
    const count = cartData.cart_count || 0

    if (this.hasCartCountTarget) {
      this.cartCountTarget.textContent = count
    }

    if (this.hasSubmitButtonTarget) {
      const enabled = cartData.submit_button_enabled && count > 0
      this.submitButtonTarget.disabled = !enabled
      this.submitButtonTarget.classList.toggle("disabled", !enabled)
    }

    if (this.hasTotalCountTarget) {
      this.totalCountTarget.value = ts.total_count || 0
    }
    if (this.hasTotalPriceTarget) {
      this.totalPriceTarget.value = (ts.total_price || 0).toLocaleString("ko-KR")
    }
    if (this.hasTotalSummaryTarget) {
      this.totalSummaryTarget.value = JSON.stringify(ts)
    }
    if (this.hasItemsTarget) {
      this.itemsTarget.value = JSON.stringify(this.items)
    }
  }
}
